/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from 'react';
import { Modal, Radio } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import $ from 'jquery';
import { v4 as uuidv4 } from 'uuid';
import Loader from '../Loader/Loader';
import api from '../../api';
import closeBtn from '../../images/common/close-btn.svg';
import WithRouter from '../Extensions/WithRouter';
import './AddVersionModal.css';

class ChangeStatusIssueModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMCS: props.isOpenMCS,
      checkedValue: props.checkedValue,
      unCheckedValue: props.unCheckedValue,
      checkAllArray: props.checkAllArray,
      rowData: props.rowData,
      isLoading: props.isLoading,
      radioValue: 'undecided',
    };
    this.handleRadioChange = this.handleRadioChange.bind(this);
    this.closeChangeStatusModal = this.closeChangeStatusModal.bind(this);
    this.updateStatusIssue = this.updateStatusIssue.bind(this);
  }

  componentDidMount() {
    $(document).on('mouseover', '.setting_popup .table_type_3 td', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  }

  componentDidUpdate(prevProps) {
    const {
      isLoading, isOpenMCS, rowData, unCheckedValue, checkAllArray, checkedValue
    } = this.props;
    if (prevProps.isLoading !== isLoading) {
      this.setState({
        isLoading,
      });
    }

    if (prevProps.isOpenMCS !== isOpenMCS) {
      this.setState({
        isOpenMCS,
        checkedValue,
        unCheckedValue,
        checkAllArray,
        rowData,
      });
    }

    if (prevProps.rowData.length !== rowData.length) {
      this.setState({
        rowData,
      });
    }
  }

  handleRadioChange(e, { value }) {
    this.setState({
      radioValue: value,
    });
  }

  uniqueFilter(array) {
    const unique = array.reduce((a, b) => {
      if (a.indexOf(b) < 0) {
        a.push(b);
      }
      return a;
    }, []);
    return unique;
  }

  updateStatusIssue() {
    const {
      radioValue, checkedValue, unCheckedValue, checkAllArray, rowData
    } = this.state;
    const { location, completeCallback } = this.props;
    const path = location.pathname ? location.pathname : location;

    let checked = [];
    let unChecked = [];

    if (checkAllArray.length !== 0) {
      checked = checked.concat(checkAllArray);
      const filterCheckAll = checkedValue.filter((item) => {
        if (typeof item === 'string') {
          const string = item.split('_');
          return checkAllArray.indexOf(Number(string[0])) === -1;
        }
        return item;
      });
      checked = this.uniqueFilter(checked.concat(filterCheckAll));
      checked = checked.map((item) => {
        if (typeof item === 'number') {
          return item.toString();
        }
        return item;
      });
      unChecked = unChecked.concat(unCheckedValue);
    } else {
      checked = this.uniqueFilter(checked.concat(checkedValue));
      checked = checked.map((item) => {
        if (typeof item === 'number') {
          return item.toString();
        }
        return item;
      });
    }

    if (path.indexOf('my_page') > -1) {
      api
        .updateStatusMyIssue(
          {
            checked,
            unchecked: unChecked,
            status: radioValue,
          }
        )
        .then((response) => {
          const uploadedFileIds = [];
          rowData.map((item) => {
            if (Array.isArray(item)) {
              return item.map((nest) => {
                return uploadedFileIds.push(nest.uploaded_file_id);
              });
            }
            return uploadedFileIds.push(item.uploaded_file_id);
          });

          const unique = uploadedFileIds.reduce((a, b) => {
            if (a.indexOf(b) < 0) {
              a.push(b);
            }
            return a;
          }, []);
          if (response.response) {
          //this.closeChangeStatusModal();
            completeCallback(unique);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      api
        .updateStatusIssue(
          {
            checked,
            unchecked: unChecked,
            status: radioValue,
          }
        )
        .then((response) => {
          const uploadedFileIds = [];
          rowData.map((item) => {
            if (Array.isArray(item)) {
              return item.map((nest) => {
                return uploadedFileIds.push(nest.uploaded_file_id);
              });
            }
            return uploadedFileIds.push(item.uploaded_file_id);
          });

          const unique = uploadedFileIds.reduce((a, b) => {
            if (a.indexOf(b) < 0) {
              a.push(b);
            }
            return a;
          }, []);

          if (response.response) {
          //this.closeChangeStatusModal();
            completeCallback(unique);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  closeChangeStatusModal() {
    const { closeModal } = this.props;
    this.setState({
      isOpenMCS: false,
    }, () => {
      closeModal();
    });
  }

  render() {
    const {
      radioValue, rowData, isLoading, isOpenMCS
    } = this.state;

    const { translate } = this.props;

    const getModalContent = () => {
      if (isLoading) {
        return (
          <div className="setting_popup_wrap">
            <div className="setting_popup applying_policy">
              <Loader />
            </div>
          </div>
        );
      }
      return (
        <div className="setting_popup_wrap">
          <div className="setting_popup applying_policy">
            <div className="setting_popup_header" style={{ position: 'relative', marginBottom: '6px' }}>
              <h2 className="popup_name">
                {translate('modal.title.changing_status')}
                <em>
                  {rowData.length}
                  {' '}
                  {translate('modal.title.selected')}
                </em>
              </h2>
              <a
                className="popup_close_button"
                onClick={this.closeChangeStatusModal}
                onKeyUp={this.closeChangeStatusModal}
                style={{ cursor: 'pointer' }}
              >
                <img src={closeBtn} alt="" />
              </a>
            </div>
            <div className="setting_popup_contnets">
              <div className="setting_popup_content_wrap">
                <table className="table changing_status_table">
                  <colgroup>
                    <col style={{ width: '50%' }} />
                    <col style={{ width: '50%' }} />
                  </colgroup>
                  <tbody>
                    <tr>
                      <td>
                        <h3 className="content_title">{translate('modal.title.current_status')}</h3>
                        <div className="setting_popup_content">
                          <div
                            className="table_wrap table_type_3"
                            style={{
                              padding: '0 10px',
                              border: '1px solid #e5e5e5',
                              borderRadius: '5px',
                            }}
                          >
                            <Scrollbars
                              style={{
                                height: '370px',
                                overflow: 'hidden',
                                position: 'relative',
                              }}
                              renderTrackHorizontal={() => {
                                return <div />;
                              }}
                              renderThumbHorizontal={() => {
                                return <div />;
                              }}
                            >
                              <table className="table table_type_3" style={{ tableLayout: 'fixed' }}>
                                <colgroup>
                                  <col style={{ width: '70%' }} />
                                  <col style={{ width: '30%' }} />
                                </colgroup>
                                <tbody>
                                  <tr>
                                    <th>{translate('modal.title.issue')}</th>
                                    <th className="tar">{translate('modal.title.status')}</th>
                                  </tr>
                                  {rowData.length !== 0
                                    ? rowData.map((list) => {
                                      if (Array.isArray(list)) {
                                        return list.map((entity) => {
                                          return (
                                            <tr key={uuidv4()}>
                                              <td className="strong ">
                                                {entity.name}
                                              </td>
                                              <td className="strong tar">
                                                <div>
                                                  {
                                                    entity.status.map((dot) => {
                                                      if (dot === 'undecided') {
                                                        return <span key={dot.toString()} className="dot blue" />;
                                                      }
                                                      if (dot === 'disregarded') {
                                                        return <span key={dot.toString()} className="dot gray" />;
                                                      }
                                                      return <span key={dot.toString()} className="dot green" />;
                                                    })
                                                  }
                                                </div>
                                              </td>
                                            </tr>
                                          );
                                        });
                                      }
                                      return (
                                        <tr key={uuidv4()}>
                                          <td className="strong ">
                                            {list.name}
                                          </td>
                                          <td className="strong tar">
                                            <div>
                                              {
                                                list.status.map((dot) => {
                                                  if (dot === 'undecided') {
                                                    return <span key={uuidv4()} className="dot blue" />;
                                                  }
                                                  if (dot === 'disregarded') {
                                                    return <span key={uuidv4()} className="dot gray" />;
                                                  }
                                                  return <span key={uuidv4()} className="dot green" />;
                                                })
                                              }
                                            </div>
                                          </td>
                                        </tr>
                                      );
                                    })
                                    : null}
                                </tbody>
                              </table>
                            </Scrollbars>
                          </div>
                        </div>
                      </td>
                      <td>
                        <h3 className="content_title">{translate('modal.title.change_to')}</h3>
                        <div className="setting_popup_content">
                          <div className="text_box">
                            <Radio
                              label={(
                                <label>
                                  <span className="dot blue" />
                                  {translate('panel.menu.undecided')}
                                </label>
                              )}
                              value="undecided"
                              checked={radioValue === 'undecided'}
                              onChange={this.handleRadioChange}
                            />
                          </div>
                          <div className="text_box">
                            <Radio
                              label={(
                                <label>
                                  <span className="dot green" />
                                  {translate('panel.menu.resolved')}
                                </label>
                              )}
                              value="resolved"
                              checked={radioValue === 'resolved'}
                              onChange={this.handleRadioChange}
                            />
                          </div>
                          <div className="text_box">
                            <Radio
                              label={(
                                <label>
                                  <span className="dot gray" />
                                  {translate('panel.menu.disregarded')}
                                </label>
                              )}
                              value="disregarded"
                              checked={radioValue === 'disregarded'}
                              onChange={this.handleRadioChange}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div
                className="setting_popup_button_wrap"
                style={{ bottom: '30px' }}
              >
                <a
                  onClick={this.closeChangeStatusModal}
                  onKeyUp={this.closeChangeStatusModal}
                  className="button cencel_button"
                  style={{ cursor: 'pointer' }}
                >
                  {translate('modal.button.cancel')}
                </a>
                <a
                  className="button save_button"
                  style={{ cursor: 'pointer' }}
                  onClick={this.updateStatusIssue}
                  onKeyUp={this.updateStatusIssue}
                >
                  {translate('modal.button.save')}
                </a>
              </div>
            </div>
          </div>
        </div>
      );
    };

    return (
      <Modal
        open={isOpenMCS}
        onClose={this.closeChangeStatusModal}
      >
        {getModalContent()}
      </Modal>
    );
  }
}

export default WithRouter(inject('state')(observer(ChangeStatusIssueModal)));
